$(function() {
    if($("#application_event_reject_extract").length){
        $(".radio").click(check_application_applicant_accepts);
        check_application_applicant_accepts()
    }
});

function check_application_applicant_accepts(){
    if ($("#application_event_reject_extract")[0].checked == true) {
        $("div.application_comment").show()
    }else{
        $("div.application_comment").hide()
    }
}
